import { render, staticRenderFns } from "./RequestInfo.vue?vue&type=template&id=01d920be&scoped=true&"
import script from "./RequestInfo.vue?vue&type=script&lang=js&"
export * from "./RequestInfo.vue?vue&type=script&lang=js&"
import style0 from "./RequestInfo.vue?vue&type=style&index=0&id=01d920be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d920be",
  null
  
)

export default component.exports